import { render, staticRenderFns } from "./ProcessedVariants.vue?vue&type=template&id=33fed9ca"
import script from "./ProcessedVariants.vue?vue&type=script&lang=js"
export * from "./ProcessedVariants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports